module.exports = __webpack_public_path__ + "c491c364554b8f20198d84c3cb93a4ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/blanket-orange-s.png
// module id = 1235
// module chunks = 0